module.exports = "<select [id]=\"this.element\" class=\"form-control select2\" [disabled]=\"disabled\"></select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/select2/select2-multi/select2-multi.component.html
// module id = ./src/app/components/tools/select2/select2-multi/select2-multi.component.html
// module chunks = main